<template>
    <div class="form-guide-flex-container-box">
        <div class="form-guide-child-box left">
            <div class="form-guide-child-item" v-if="homeTeam">
                <div class="form-guide-child-item-box">
        
                    <div class="form-guide-child-result">
                    <!-- {{ i }} -->
                        <Navigation
                            :id="homeTeam.homeTeamId"
                            :category="'team'"
                            :name="homeTeam.homeTeamName">
                            <Icon
                                :logoUrl="homeTeam.homeLogo"
                                hasClass="form-guide-child-logo-icon"
                            ></Icon>
                        </Navigation>
                        <div class="form-guide-child-result-score">
                            {{homeTeam.homeTeamScore}} 
                            <span class="dash-padding">-</span>
                            {{ homeTeam.awayTeamScore }}
                        </div>
                        <Navigation
                            :id="homeTeam.awayTeamId"
                            :category="'team'"
                            :name="homeTeam.awayTeamName">
                            <Icon
                                :logoUrl="homeTeam.awayLogo"
                                hasClass="form-guide-child-logo-icon"
                            ></Icon>
                        </Navigation>
                        <!-- <div class="form-guide-child-result-winlose winlose-right"
                            :class="`winlose-${2}`"> -->
                            <!-- {{ child.winlose === '0' ? 'W' :
                                child.winlose === '1' ? 'D' :
                                child.winlose === '2' ? 'L' : ''
                            }} -->
                            <!-- L
                        </div> -->
                    </div>
                    <div class="form-guide-child-name">
                        <!-- {{  
                            i
                        }} -->
                        {{ otherTeamName(homeTeam, matchDetailScore.homeTeamName) }}
                    </div>
                </div>
            </div>
        </div>

        <div class="form-guide-child-box right">
            <div class="form-guide-child-item"  v-if="awayTeam">
                <div class="form-guide-child-item-box">
        
                    <div class="form-guide-child-result right">
                    <!-- {{ i }} -->
                        <Navigation
                            :id="awayTeam.homeTeamId"
                            :category="'team'"
                            :name="awayTeam.homeTeamName">
                            <Icon
                                :logoUrl="awayTeam.homeLogo"
                                hasClass="form-guide-child-logo-icon"
                            ></Icon>
                        </Navigation>
                        <div class="form-guide-child-result-score">
                            {{awayTeam.homeTeamScore}} 
                            <span class="dash-padding">-</span>
                            {{ awayTeam.awayTeamScore }}
                        </div>
                        <Navigation
                            :id="awayTeam.awayTeamId"
                            :category="'team'"
                            :name="awayTeam.awayTeamName">
                            <Icon
                                :logoUrl="awayTeam.awayLogo"
                                hasClass="form-guide-child-logo-icon"
                            ></Icon>
                        </Navigation>
                    </div>
                    <div class="form-guide-child-name">
                        <!-- {{  
                            i
                        }} -->
                        {{ otherTeamName(awayTeam, matchDetailScore.awayTeamName) }}
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>
export default {
    props: [
        "homeTeam",
        "awayTeam",
        "matchDetailScore"
    ],
    methods: {
        otherTeamName(i, fatherTeamName) {
            if(i.homeTeamName !== fatherTeamName) {
                return i.homeTeamName
            } else if(i.awayTeamName !== fatherTeamName) {
                return i.awayTeamName
            }
        },
    }
}
    </script>

<style scoped>

.form-guide-flex-container-box {
    width: 100%;
    display: flex;
    align-items: center;
    /* gap: 200px; */
    flex-shrink: 0;
    justify-content: center;
    border-bottom: 1px dotted var(--color-border-default-default);
    padding: 16px 0;
}
.form-guide-child-box {
    width: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
}
.form-guide-child-box.left {
    padding-left: 100px;
}
.form-guide-child-box.right {
    padding-right: 100px;
    /* justify-content: left; */
}
.form-guide-header-box,
.form-guide-header-box .form-guide-flex-container-box {
    width: auto;
    min-width: 98px;
}

.form-guide-header {
    text-align: center;
    
}
.form-guide-logo-icon {
    width: 34px;
    margin: auto;
    display: block;
}
.form-guide-header-title {
    font-size: var(--typography-body-size-small);
    font-family: var(--weight-700);
    letter-spacing: 0.64px;
    margin-top: 4px;
}
.form-guide-child-list {
    margin-top: 16px;
}
.form-guide-child-item {
    margin-bottom: 8px;
    padding-bottom: 8px;
    border-bottom: 1px dashed var(--gray-300);
    display: flex;
    justify-content: right;
}
.form-guide-child-item.right {
    justify-content: left;
}
.form-guide-child-item-box {
    width: 176px;
}
.form-guide-child-item:last-child {
    
    margin-bottom: 0;
    padding-bottom: 0;
    border-bottom: 0;
}
.form-guide-item {
    width: 100%;
}
.form-guide-child-result {
    display: flex;
    align-items: center;
    /* justify-content: right; */
    justify-content: center;
    position: relative;

}
.form-guide-child-result.right {
    /* justify-content: left; */
}

.form-guide-child-logo-icon {
    width: 40px;
    height: 40px;
    flex-shrink: 0;
    display: inherit;
}
.form-guide-child-result-score {
    font-size: 24px;
	letter-spacing: -0.64px;
  font-family: var(--weight-600);
    padding: 0 12px;
    position: relative;
    flex-shrink: 0;
}
.form-guide-child-result-winlose {
    position: absolute;
    width: 20px;
    height: 20px;
    border-radius: 50%;
    font-family: var(--weight-700);
    font-size: 12px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--white-1000);
	letter-spacing: 0.2px;
}
.winlose-0 {
    background-color: var(--success-500);
}
.winlose-1 {
    background-color: var(--error-500);
}
.winlose-2 {
    background-color: var(--gray-500);
}
.winlose-left {
    left: -32px;
}
.winlose-right {
    right: -32px;
}
/* .form-guide-flex-container-box:nth-child(odd) .winlose-left {
    display: none;
}
.form-guide-flex-container-box:nth-child(even) .winlose-right {
    display: none;
} */
.form-guide-child-name {
    font-size: 16px;
    font-family: var(--weight-400);
    padding-top: 8px;
    text-align: center;
}
.dash-padding {
    padding: 0 8px;
}

@media(max-width: 768px) {  /* for test */
    .form-guide-child-name {
    font-size: 13px;
    font-family: var(--weight-400);
    padding-top: 7.33px;
    text-align: center;
}
.match-details__stats-container {
  background-color: var(--color-background-default-secondary);
  border-radius: 8px;
  margin-top: 16px;
  padding: 16px;
}
.match-detail__stats-header {
  margin-top: 0;
	letter-spacing: -0.64px;
  font-family: var(--weight-600);
  padding-top: 0;
}
.form-guide-flex-container {
    display: flex;
    justify-content: center;
}
.form-guide-child-box.left {
    padding-left: 0;
}
.form-guide-child-box.right {
    padding-right: 0;
    /* justify-content: left; */
}
.form-guide-flex-container-box {
    align-items: baseline;
}
.form-guide-header-title {
    font-size: 13px;
}
.form-guide-child-result-score {
    font-size: 16px;
	letter-spacing: 0.64px;
}
.form-guide-child-logo-icon {
    width: 24px;
    height: 24px;
}
.dash-padding {
    padding: 0;
}
}
</style>